import { createStore } from "zustand/vanilla"

import { AppUserDataLoader } from "@/data/dataLoader"
import { CustomerProfile, MerchantCouponRedeemer, MerchantProfile } from "@/lib/zenstack/models"

export interface ZuProfileProviderState {
  customer?: CustomerProfile | null
  merchant?: MerchantProfile | null
  merchantCouponRedeemer?: MerchantCouponRedeemer | null
}

export interface AppState {
  isMobile: boolean

  appUser?: AppUserDataLoader | null

  profiles: ZuProfileProviderState

  progress: number
  isProgressVisible: boolean

  impersonationJwt?: string
}
export interface AppStateActions {
  setIsMobile: (isMobile: boolean) => void
  setAppUser: (user: AppUserDataLoader | null) => void
  setProfiles: (profiles: ZuProfileProviderState) => void
  setProgressVisible: (progress: number, visible: boolean) => void
  setImpersonationJwt: (impersonationJwt: string | undefined) => void
}

export const defaultInitState: AppState = {
  isMobile: false,
  appUser: null,
  profiles: {
    customer: undefined,
    merchant: undefined,
    merchantCouponRedeemer: undefined,
  },
  progress: 0,
  isProgressVisible: false,
  impersonationJwt: undefined,
}

export const createAppStore = (initState: AppState = defaultInitState) => {
  return createStore<AppState & AppStateActions>()((set) => ({
    ...initState,
    setIsMobile: (isMobile) => set({ isMobile }),
    setAppUser: (appUser) => set({ appUser }),
    setProfiles: (profiles) => set({ profiles }),
    setProgressVisible: (progress, isProgressVisible) => set({ progress, isProgressVisible }),
    setImpersonationJwt: (impersonationJwt) => set({ impersonationJwt }),
  }))
}
